import { render, staticRenderFns } from "./BlockCTA.vue?vue&type=template&id=2cd2a025&"
import script from "./BlockCTA.vue?vue&type=script&lang=js&"
export * from "./BlockCTA.vue?vue&type=script&lang=js&"
import style0 from "./BlockCTA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports